import { Classes, Icon } from '@blueprintjs/core';
import * as React from 'react';

import type { Vendor } from '../types';

import RetryHelpText from './RetryHelpText';

export interface VendorSelectProps {
  selectedId: string | null;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => void;
  disabled?: boolean;
  name?: string;
}

interface Props extends VendorSelectProps {
  vendors: Vendor[];
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
}

export default function VendorSelect({
  handleChange,
  selectedId,
  vendors,
  disabled,
  name = 'vendor',
  isLoading,
  isError,
  onRetry,
}: Props) {
  return (
    <>
      <div className={Classes.HTML_SELECT}>
        <select
          onChange={handleChange}
          value={selectedId || ''}
          name={name}
          disabled={disabled || isLoading || (isError && vendors.length === 0)}
          aria-busy={isLoading}
        >
          <option value="">{isLoading ? 'Loading...' : '---'}</option>
          {vendors.map((vendor) => (
            <option key={vendor.id} value={vendor.id}>
              {vendor.name}
            </option>
          ))}
        </select>
        <Icon icon="double-caret-vertical" />
      </div>
      {isError && <RetryHelpText message="Unable to load options." onRetry={onRetry} />}
    </>
  );
}
